<template>
    <div class="m-invite">
        <div class="title"></div>

        <!-- invite task -->
         <div class="task-pannel">
            <div class="task-item" v-for="(task,index) in task_config" :key="index">
                <div class="task-name" :class="'t-' + (index + 1)"></div>
                <div class="task-content flex-between-start">
                    <p>{{ task.content }}</p>
                    <div class="rate">({{ $store.state.userinfo.uid ? task_info[task.key] : 0 }}/{{ task.max }})</div>
                </div>
                <div class="task-detail flex-between-center">
                    <div class="reward-list flex-between-center">
                        <div class="gift-pic" v-for="(gift,k) in task.reward_list" :key="'r-' + k" v-tips="gift.giftId">
                            <div class="wrapper">
                                <game-item :id="gift.giftId" :num="gift.sendNum" :locked="true"></game-item>
                            </div>                         
                        </div>
                    </div>
                    <div class="u-btn apply" :class="{'dismiss' : task_info[task.key] == task_info[task.rate] && task_info[task.rate] , 'disabled' : !task_info[task.rate] }"
                    @click="call_task_apply(task.ajax,task)"></div>
                </div>
            </div>
         </div>
        <!-- end -->

        <!-- invite player -->
        <div class="invite-player">
            <div class="slogen"></div>
            <div class="u-btn invite-rule" @click="$evt_rule({type : 'invite'})"></div>
            <div class="invite-pannel">
                <div class="invite-list">
                    <div class="table-head"></div>
                    <div class="table-view">
                        <vuescroll>
                            <table>
                                <tbody>
                                    <tr v-for="(player,index) in invite_list" :key="index">
                                        <td style="width: 102px;">{{ player.self ? '本人' : '被邀请' }}</td>
                                        <td style="width: 190px;"><p class="text-overflow-1">{{ player.nickName }}</p></td>
                                        <td style="width: 190px;">{{ player.isBuy ? '是' : '否' }}</td>
                                        <td>{{ player.score }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </vuescroll>
                    </div>
                </div>
                <div class="u-btn invite" @click="call_invite()"></div>
            </div>
        </div>
        <!-- end -->
    </div>
</template>

<script>
import {
    apiInviteTask,
    apiInviteList,
    apiInviteCode,
    apiGiftXy,
    apiGiftHy,
    apiGiftKk,
} from '@/api/index';

export default {
    data(){
        return {
            task_config : [
                {
                    content : '邀请其他玩家进行绑定，本人可领取1次奖励',
                    max : 3,
                    reward_list :[
                        {"giftId":"1","giftName":"金鸡币","sendNum":"5"},
                        {"giftId":"NH05","giftName":"活跃自选礼包（7天）","sendNum":"1"},
                        {"giftId":"AN07","giftName":"小士兵卡(7天)","sendNum":"5"},
                    ],                    
                    key : '1-1',
                    rate : '1-2',
                    ajax : apiGiftXy,
                },
                {
                    content : '每名邀请的玩家达到1000经验时，本人可领取1次奖励',
                    max : 3,
                    reward_list : [
                        {"giftId":"PK04","giftName":"春节活跃抽奖券","sendNum":"2"},
                        {"giftId":"1","giftName":"金鸡币","sendNum":"5"},
                        {"giftId":"KR48","giftName":"竞技地图畅玩礼包（7天）","sendNum":"1"},
                    ],
                    key : '2-1',
                    rate : '2-2',
                    ajax : apiGiftHy,                    
                },
                {
                    content : '本人和邀请的玩家均购买沙场争霸通行证，本人可领取奖励1次奖励',
                    max : 3,
                    reward_list : [
                        {"giftId":"PK04","giftName":"春节活跃抽奖券","sendNum":"5"},
                        {"giftId":"1","giftName":"金鸡币","sendNum":"10"},
                        {"giftId":"Y550","giftName":"超炫酷玩具自选包（7天）","sendNum":"1"}
                    ],
                    key : '3-1',
                    rate : '3-2',
                    ajax : apiGiftKk,                    
                },
            ],
            task_info : {},
            invite_list : [],
        }
    },
    mounted(){
        this.invite_info();
    },
    computed :{
        _zid (){
            return this.$store.state.userinfo.areaId;
        },    
    },
    watch : {
        _zid : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    this.invite_info();
                }              
            },
            deep: true
        },                         
    },      
    methods : {
        invite_info (){
            apiInviteTask().then(
                res => {
                    this.task_info = res.data;
                }
            )

            apiInviteList().then(
                res => {
                    this.invite_list = res.data.reverse()
                },
            )
        },
        call_task_apply(ajax_fuc,task){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            //'dismiss' : task_info[task.key] == task_info[task.rate] && task_info[task.rate] , 'disabled' : !task_info[task.rate]
            if(this.task_info[task.key] == this.task_info[task.rate] && this.task_info[task.rate])return;
            if(!this.task_info[task.rate])return;
           
            ajax_fuc().then(
                res => {
                    this.$msg_modal('领取成功~');
                    this.invite_info();
                },
                rej => {
                    this.$msg_modal(rej.message);
                }
            )
        },
        call_invite(){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            apiInviteCode({}).then(
                res => {
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url; 
                    this.$copy_modal({ shareTxt : shareTxt });                   
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },        
    }
}
</script>

<style lang="scss" scoped>
.title{
    width: 535px;
    height: 161px;
    margin: 0 auto 25px;
    background-image: url(~@/assets/images/title-3.png);
}

.task-pannel{
    .task-item{
        width: 706px;
        height: 303px;
        margin: 0 auto 35px;
        padding: 30px 40px 0;
        box-sizing: border-box;
        background-image: url(~@/assets/images/task-item.png);

        .task-detail{
           margin-top: 10px;
        }

        .task-name{
            width: 164px;
            height: 44px;
            margin-bottom: 10px;
            
            &.t-1{
                background-image: url(~@/assets/images/t-xy.png);
            }
            
            &.t-2{
                background-image: url(~@/assets/images/t-hy.png);
            }  
            
            &.t-3{
                background-image: url(~@/assets/images/t-kk.png);
            }              
        }

        .task-content{
            height: 50px;
            font-size: 22px;
            color: #e2c3a3;

            p{
                width: 490px;
                margin: 0;
            }
        }

        .reward-list{
            margin-top: 25px;
            .gift-pic{
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 91px;
                height: 91px;
                margin-right: 20px;
                background-image: url(~@/assets/images/bg-item_zb.png);

                .wrapper{
                    width: 68px;
                    height: 68px;
                }
            }
        }

        .u-btn.apply{
            width: 173px;
            height: 73px;
            background-image: url(~@/assets/images/task-apply.png);

            &.dismiss{
                background-image: url(~@/assets/images/task-dismiss.png);
            }

            &.disabled{
                background-image: url(~@/assets/images/task-disabled.png);
            }            
        }
    }
}

.invite-player{
    margin-top: 70px;

    .slogen{
        position: relative;
        width: 640px;
        height: 106px;
        margin: 0 auto;
        // transform: translateX(-30px);
        background-image: url(~@/assets/images/title-invite.png);        
    }

    .invite-rule{
        position: relative;
        width: 149px;
        height: 38px;
        margin: 20px auto 0;
        background-image: url(~@/assets/images/invite-rule.png);         
    }

    .invite-pannel{
        position: relative;
        width: 706px;
        height: 486px;
        margin: 30px auto 0;
        padding-top: 60px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/pannel-invite.png);         
    }

    .invite-list{
        .table-head{
            width: 622px;
            height: 48px;
            margin: 0 auto;
            background-image: url(~@/assets/images/invite-head.png);     
        }

        .table-view{
            width: 622px;
            height: 360px;
            margin: 2px auto 0;

            table{
                width: 622px;
                text-align: center;
                font-size: 22px;
                color: #e2c3a3;
                border-collapse:collapse;
            }

            tr{
                border-bottom: 1px solid #e2c3a3;
            }

            td{
                padding: 22px 0;
            }

        }
    }

    .u-btn.invite{
        position: absolute;
        left: 50%;
        bottom: 40px;
        transform: translateX(-50%);
        width: 270px;
        height: 82px;
        background-image: url(~@/assets/images/btn-invite.png);  
    }
}
</style>